import { render, staticRenderFns } from "./produksimpanan.vue?vue&type=template&id=0715aaa9&scoped=true"
import script from "./produksimpanan.vue?vue&type=script&lang=js"
export * from "./produksimpanan.vue?vue&type=script&lang=js"
import style0 from "./produksimpanan.vue?vue&type=style&index=0&id=0715aaa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0715aaa9",
  null
  
)

export default component.exports